var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/ability-question-new.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-4453f8a6!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/ability-question-new.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/AbilityQuestionNew.vue
// module id = 602
// module chunks = 1